import { DateTimePicker, DateTimePickerProps } from '@mantine/dates'
import { Ref, forwardRef } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type InputDatetimePickerProps = Omit<
  DateTimePickerProps,
  'value' | 'onChange' | 'icon' | 'ref'
> & {
  value?: string | undefined
  onChange?: (_val: string | undefined) => void
  icon?: React.ReactNode
}

export const InputDatetimePicker = (
  props: InputDatetimePickerProps & { name: string },
) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field: { ref, ...field }, fieldState }) => {
        const { error } = fieldState
        return (
          <DateTimePickerPure
            {...field}
            {...props}
            ref={ref}
            error={error?.message}
            leftSection={props.icon}
          />
        )
      }}
    />
  )
}

const DateTimePickerPure = forwardRef(
  (props: InputDatetimePickerProps, ref: Ref<HTMLButtonElement>) => {
    const { setValue } = useFormContext()
    const onChange = (value: string | null) => {
      props?.onChange?.(value ?? undefined)
    }

    return (
      <DateTimePicker
        ref={ref as Ref<HTMLButtonElement>}
        {...props}
        value={props.value ?? null}
        onChange={onChange}
        clearButtonProps={{
          onClick: () => {
            onChange(null)
            setValue(props.name!, null)
          },
        }}
      />
    )
  },
)

DateTimePickerPure.displayName = 'DateTimePickerPure'
